import React, { useState, useEffect } from 'react';
import { Box, Typography, Switch, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useFilterContext } from './filtercontext';

export default function SwitchFilter({
  field,
  defaultValue = false,
  label = "Option",
  // placeholder = "Search...",
}) {
  const { registerFilter, clearFilter } = useFilterContext();

  // State for switch value
  const [switchValue, setSwitchValue] = useState(defaultValue);

  // Generate a unique field name for this filter
  const filterId = `switch_${label.replace(/\s+/g, '_').toLowerCase()}`;

  // Create clear handler function
  const handleClearFromContext = () => {
    setSwitchValue(defaultValue);
  };

  // Update filter when switch value changes
  useEffect(() => {

        const filterFn = item => {

          // If switch is off, include all items, else only include those matching the switch
          return (!switchValue || item[field] === switchValue);
        };

        const handleFilterDescription = () => {
          return `${label}: ${switchValue ? 'On' : 'Off'}`;
        };

        if (switchValue !== defaultValue) {
          registerFilter(field, label, filterFn, handleClearFromContext, handleFilterDescription);
        } else {
          clearFilter(field);
        }




  }, [switchValue, filterId]);

  // Clear search
  const handleClearSearch = () => {
    setSwitchValue(defaultValue);
  };

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>

      <Switch
        checked={switchValue}
        onChange={(e) => setSwitchValue(e.target.checked)}
        color="primary"
        inputProps={{ 'aria-label': label }}
      />
    </Box>
  );
}